import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import type { SelectionSidebarItem } from './selection-sidebar-item.type';

@Component({
  selector: 'procure-selection-sidebar',
  templateUrl: './selection-sidebar.component.html',
  styleUrl: './selection-sidebar.component.scss',
  imports: [MatIcon, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionSidebar {
  readonly items = input.required<SelectionSidebarItem[]>();
  readonly titleTemplate = input<TemplateRef<{
    $implicit: SelectionSidebarItem;
  }> | null>(null);

  readonly itemSelect = output<string>();
}
